import { render, staticRenderFns } from "./Awaiting.vue?vue&type=template&id=0ccce8b2"
import script from "./Awaiting.vue?vue&type=script&lang=js"
export * from "./Awaiting.vue?vue&type=script&lang=js"
import style0 from "./Awaiting.vue?vue&type=style&index=0&id=0ccce8b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports